/**
 * Apply ±20% additive jitter to a delay so a fleet of devices that lost the
 * same upstream at the same moment doesn't hammer the server on perfectly
 * aligned offsets after recovery.
 *
 * We use additive ±20% rather than full jitter (0..delayMs) so the actual
 * delay stays close to the configured backoff schedule — operators reading
 * logs can still reason about cadence, and a too-short retry doesn't burn
 * the device's budget on a single tier.
 *
 * Returns 0 for non-positive inputs (defensive — `setTimeout(0)` is a valid
 * caller intent for "fire as soon as possible").
 */
export function jitter(delayMs) {
    if (delayMs <= 0)
        return 0;
    const spread = delayMs * 0.2;
    return Math.round(delayMs + (Math.random() * 2 - 1) * spread);
}
//# sourceMappingURL=Jitter.js.map